<template>
  <div class="page page-reservation">
    <div class="top-layout">
      <div class="top">
        卫人派遣官方预约服务通道
      </div>
      <div class="position-info">
        <div class="name">北京卫人人力资源开发有限公司</div>
        <div class="address">
          <img src="~@/assets/ic_addr.png" alt="">
          北京市西城区车公庄大街9号院1号楼2门701室
        </div>
        <div class="address">
          <img src="~@/assets/ic_time.png" alt="">
          工作时间：8:30-11:15，13:30-16:45[工作日]
        </div>
      </div>
    </div>
    <div class="divider"/>
    <div style="position: relative;">
      <div v-if="!showCalendar" class="week-wrapper">
        <div class="week-info">
          <div :class="'day-info' + (selectDate === dayInfo.date?' select':'')" v-for="dayInfo in dayList"
               @click="handleClickDay(dayInfo)">
            <div>{{ dayInfo.day }}</div>
            <div>{{ dayInfo.date }}</div>
            <div>
              <span v-if="dayInfo.hasRemain===true" class="has">
                {{ dayInfo.fullDate > endFullDate ? '待放号' : '有号' }}
              </span>
              <span v-else class="no">
                无号
              </span>
            </div>
          </div>
          <div @click="showCalendar = true" class="day-info more">
            <div>更多</div>
            <div>日期</div>
          </div>
        </div>
        <van-row v-if="planList.length > 0" style="border-top: 1px solid #eee; ">
          <van-col v-for="plan in planList" span="8">
            <div :class="{'plan-desc':true,'plan-desc-select':plan.uuid === planDetail.uuid}"
                 @click="showPlanDetail(plan)">
              <div>{{ plan.startTime }}-{{ plan.endTime }}</div>
              <div>剩余{{ plan.remainNum }}</div>
            </div>
          </van-col>
        </van-row>
      </div>
      <transition name="cc">
        <div v-if="showCalendar" class="calendar-wrapper">
          <van-calendar
              title="日历"
              :show-title="false"
              :poppable="false"
              :default-date="calendarDate"
              @select="handleSelectCalendar"
              :min-date="minDate"
              color="#408CF8"
              row-height="60"
              :max-date="maxDate"
              :formatter="calendarFormatter"
              :show-confirm="false"
          />
          <div class="calendar-action" @click="showCalendar = false">收起日历</div>
        </div>
      </transition>
    </div>
    <template v-if="planList.length===0">
      <van-empty class="empty" description="该日期没有数据，请关注其他日期" image-size="147px">
        <img slot="image" src="~@/assets/empty.png" style="width: 147px;height: 95px;" alt="">
      </van-empty>
    </template>
    <div v-else-if="planDetail.uuid" class="time-config">
      <div class="time-title">{{ planDetail.planDate }} {{ planDetail.title }}</div>
      <van-cell-group>
        <van-cell title="服务时间" :value="planDetail.startTime +'-'+planDetail.endTime" :border="false"/>
      </van-cell-group>
      <van-collapse v-model="activeService">
        <van-collapse-item v-for="service in serviceList" :title="service.title" :name="service.id" value="业务要求">
          <div v-html="service.requirement" style="white-space: pre-wrap"></div>
        </van-collapse-item>
      </van-collapse>
    </div>
    <van-button v-if="planDetail.uuid" class="action" :disabled="planDetail.remainNum <=0 "
                @click="handleGoNext(planDetail)" round type="info">预约服务
    </van-button>
    <!--    <van-popup v-model="isShowPop" round>-->
    <!--      <div class="prview-content">-->
    <!--        <div class="content">-->
    <!--          1、根据北京市疫情防控要求，所有人员进入北京卫人人力资源开发有限公司办理业务，在扫码、测温的同时，需核验48小时内核酸检测阴性证明、“北京健康宝”绿码。核酸检测阴性证明以“北京健康宝”核酸查询结果或纸质版报告为凭证，“北京健康宝”以核酸检测时间为准，纸质版报告以报告时间为准。为确保顺利就办理业务，请您根据预约时间，提前进行核酸检测。-->
    <!--          <br/>-->
    <!--          2、10天内来自境外及港澳台地区，7天内来自中高风险地区，或有其他流行病学史、接触史，以及健康宝黄码或红码等情形的人员，请解除弹窗后再预约办理业务。-->
    <!--        </div>-->
    <!--        <van-button @click="loadCalendarData" round type="info" style="margin-top: 10px;height: 40px;">知道了</van-button>-->
    <!--      </div>-->
    <!--    </van-popup>-->
    <van-button round class="btn-to-my" color="#408CF8" icon="user-o" size="mini" type="primary" @click="handleGoMy">
      我的预约
    </van-button>
  </div>
</template>

<script>
import {serviceList} from '@/api/reservation'
import {appointmentCalendar, appointPlan} from '@/api/reservation'

import mixinLoad from '@/mixin/mixin-load.js';
import moment from 'moment'
import {checkService} from "@/api/user";

const startDate = moment().startOf('days').toDate();
const endDate = moment().isoWeekday(7).date(1).add(2, 'month').add(-1, 'day').endOf('days').toDate();
const startFullDate = moment().add(0, 'days').format('YYYY-MM-DD');
// 允许预约 本周 + 下周的计划：自然周 设置为周日，再叠加到下一周
const endFullDate = moment().isoWeekday(7).date(1).add(2, 'month').add(-1, 'day').format('YYYY-MM-DD');
export default {
  mixins: [mixinLoad],
  data() {
    return {
      endFullDate,
      activeService: [],
      serviceList: [],
      showCalendar: false,
      dayList: [],
      planCalendar: {},
      selectDate: null,
      calendarDate: null,
      isAgree: false,
      detailInfo: {},
      minDate: startDate,
      maxDate: endDate,
      planList: [],
      planDetail: {},
    };
  },
  methods: {
    calendarFormatter(day) {
      const fullDate = moment(day.date.getTime()).format('YYYY-MM-DD')
      if (fullDate < startFullDate) {
        day.className = 'old-date'
        day.bottomInfo = '';
        return day
      }
      const planDataInfo = this.planCalendar[fullDate];
      if (planDataInfo) {
        if (fullDate > endFullDate) {
          day.bottomInfo = '待放号';
        } else {
          if (planDataInfo.hasRemain) {
            day.bottomInfo = '有号';
            day.className = 'day-has'
          } else {
            day.bottomInfo = '无号';
            day.className = 'day-no'
          }
        }
      } else {
        day.bottomInfo = '无号';
        day.className = 'day-no'
      }
      return day;
    },
    /**
     * 选择日期，如果日期没有出现在头部星期列表的时候，需要更新星期列表
     * @param date
     */
    handleSelectCalendar(date) {
      this.calendarDate = date;
      this.selectDate = moment(date.getTime()).format('MM-DD');
      // 如果日期没有出现在头部星期列表的时候，需要更新星期列表
      this.dayList = this.createDayLine(date)
      this.loadPlanList();
    },
    handleClickDay(dayInfo) {
      this.calendarDate = new Date(dayInfo.fullDate);
      this.selectDate = dayInfo.date;
      // 大于截止日期
      if (dayInfo.fullDate > endFullDate) {
        this.planDetail = {}
        this.planList = [];
        return;
      }
      this.loadPlanList();
    },
    loadPlanList() {
      this.planDetail = {}
      this.showCalendar = false;
      const planDate = moment(this.calendarDate.getTime()).format('YYYY-MM-DD');
      const planInfo = this.planCalendar[planDate];
      if (planInfo) {
        const typeId = planInfo.typeId;
        const loading = this.showLoading();
        appointPlan({typeId: typeId, planDate: planDate}).then((rep) => {
          loading.close();
          this.planList = rep.data;
          if (this.planList.length > 0) {
            this.showPlanDetail(this.planList[0])
          } else {
            this.planDetail = {}
          }
        }).catch(() => {
          loading.close();
        })
      } else {
        //  完全没号
        this.planList = [];
      }
    },
    showPlanDetail(plan) {
      this.planDetail = plan;
    },
    handleGoMy() {
      this.$router.push({path: '/reservation-my'});
    },
    isBeforeTime(plan) {
      const endDateTime = moment(`${plan.planDate} ${plan.endTime}:00`)
      return moment().isBefore(endDateTime);
    },
    handleGoNext(plan) {
      this.$router.push({
        path: '/reservation-preview?uuid=' + plan.uuid
      });
    },
    /**
     * 如果date 已出现在现有数据内，则不在生成数据，否则以date为第一天生成剩余日期
     * @param date
     * @returns {[]|*[]}
     */
    createDayLine(date) {

      const nowDate = moment();
      const requireDate = moment(date.getTime());
      const requireDateStr = requireDate.format('YYYY-MM-DD');
      // 如果不包含在已有的星期数据里的话，需要重建星期列表
      if (!this.dayList.find((day) => {
        return day.fullDate === requireDateStr;
      })) {
        const weeks = ['周日', '周一', '周二', '周三', '周四', '周五', '周六'];
        let date = requireDate;
        const dayList = [];
        for (let i = 0; i < 6; i++) {
          const dayItem = {
            day: date.isSame(nowDate, 'day') ? '今日' : weeks[date.day()],
            date: date.format('MM-DD'),
            fullDate: date.format('YYYY-MM-DD'),
            hasRemain: null,
            typeId: null
          };
          const planRemainObj = this.planCalendar[dayItem.fullDate];
          if (planRemainObj) {
            dayItem.hasRemain = planRemainObj.hasRemain
            dayItem.typeId = planRemainObj.typeId
          }
          dayList.push(dayItem)
          date.add(1, 'day')
        }
        return dayList;
      } else {
        return this.dayList;
      }
    },
    loadCalendarData() {
      const loading = this.showLoading();
      appointmentCalendar().then((rep) => {
        loading.close();
        const dataList = rep.data;
        dataList.forEach((item) => {
          this.planCalendar[item.planDate] = item;
        })
        this.dayList = this.createDayLine(new Date());
        this.handleClickDay(this.dayList[0]);
      }).catch(() => {
        loading.close();
      })
    }
  },
  created() {
    const loading = this.showLoading();
    Promise.all([checkService('bindPersonnel'), this.preCheck()]).then(() => {
      serviceList().then((rep) => {
        loading.close();
        this.serviceList = rep.data;
        this.loadCalendarData();
      }).catch(() => {
        loading.close();
      })
    }).catch(() => {
      loading.close();
    });
  }
};
</script>

<style scoped>
.top-layout, .empty {
  background: #FFFFFF;
  box-shadow: 0px 2px 7px 0px rgba(0, 0, 0, 0.12);
  border-radius: 10px;
  margin: 12px;
}

.divider {
  height: 30px;
  text-align: center;
  background: url("~@/assets/line.png") no-repeat center;
}

.page-reservation >>> .van-popup--center.van-popup--round {
  border-radius: 8px;
  background-color: #f5f7f9;
}

.page-reservation {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

.page-reservation >>> .van-cell {
  color: #000;
  font-size: 14px;
  font-weight: 500;
}

.top {
  text-align: center;
  line-height: 30px;
  height: 30px;
  background: #408CF8;
  z-index: 2;
  color: #fff;
  font-size: 16px;
  padding: 6px;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}

.position-info {
  padding: 10px;
  z-index: 2;
  margin-left: 5px;
  margin-right: 5px;
}

.position-info .name {
  font-weight: 800;
  color: #408CF8;
}

.position-info .address {
  font-size: 12px;
  margin-top: 5px;
}

.prview-content {
  min-width: 80vw;
  height: 80vh;
  padding: 16px 10px;
  position: relative;
  display: flex;
  flex-direction: column;
}

.prview-content .content {
  background: #fff;
  border-radius: 6px;
  padding: 16px;
  font-size: 14px;
  line-height: 22px;
  overflow-y: scroll;
  flex-grow: 1;
}

.week-wrapper {
  background: #FFFFFF;
  box-shadow: 0px 2px 7px 0px rgba(0, 0, 0, 0.12);
  border-radius: 10px;
  margin: 12px;
}

.week-info {
  display: flex;
  z-index: 2;
}

.day-info {
  width: 30px;
  flex-grow: 1;
  text-align: center;
  font-size: 12px;
  padding: 5px 2px;
  display: flex;
  flex-direction: column;
  align-self: center;
}

.day-info .has {
  color: #408CF8;
}

.day-info.select .has {
  color: #FFF;
}

.day-info.select {
  background: #408CF8;
  color: #FFF;
}

.day-info.more {
  color: #408CF8;
}

.plan-desc {
  padding: 4px;
  font-size: 12px;
  text-align: center;
  border-top: 1px solid #eee;
  margin-top: -1px;
  border-right: 1px solid #eee;
}

.plan-desc-select {
  color: #408CF8;
  border-top: 1px solid #408CF8;
  border-right: 1px solid #eee;
  background-color: #E0EFFF;
}

.time-config {
  display: flex;
  flex-direction: column;
  position: relative;
  background: #FFFFFF;
  box-shadow: 0px 2px 7px 0px rgba(0, 0, 0, 0.12);
  border-radius: 10px;
  margin: 12px;
}

.time-config >>> .van-cell, .time-config >>> .van-collapse-item__content {
  background: none;
}

.time-config .time-title {
  font-size: 16px;
  font-weight: 800;
  padding: 10px 16px;
  border-bottom: 1px solid #eee;
}

.time-config .time-detail {
  padding: 10px;
}

.time-config .time-desc {
  font-size: 15px;
  padding: 0 16px 16px 16px;
}

.time-config .time-action {
  position: absolute;
  right: 10px;
  top: 55px;
}

.notice {
  padding: 10px 16px;
  line-height: 26px;
}

.calendar-wrapper {
  position: relative;
  left: 0;
  top: 0;
  right: 0;
  z-index: 2;
  background: #FFFFFF;
  box-shadow: 0px 2px 7px 0px rgba(0, 0, 0, 0.12);
  border-radius: 10px;
  margin: 12px;
}

.van-calendar {
  background: none;
}

.calendar-wrapper .calendar-action {
  position: absolute;
  right: 0px;
  top: 0px;
  font-size: 14px;
  padding: 10px;
  color: #408CF8;
}

/*进入 / 离开 过度生效状态 */
.cc-enter-active {
  transition: all .5s;
}

/* 进入状态 & 结束状态 opacity为0 */
.cc-enter {
  opacity: 0;
  transform: translateY(10px);
}

.btn-to-my {
  margin: 8px;
  position: fixed;
  right: 5px;
  top: 15px;
}

.action {
  margin-left: 50px;
  margin-right: 50px;
  margin-top: 20px;
}

</style>
